import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function Footer() {
  const { t } = useTranslation('common');

  return (
    <footer className="bg-foreground-900 text-background-50 relative overflow-hidden">
      {/* Subtle map pattern */}
      <div className="absolute inset-0 opacity-5 pointer-events-none">
        <div className="w-full h-full" style={{
          backgroundImage: 'radial-gradient(circle at 20% 30%, rgba(255,255,255,0.15) 1px, transparent 1px), radial-gradient(circle at 80% 70%, rgba(255,255,255,0.1) 1px, transparent 1px)',
          backgroundSize: '60px 60px, 40px 40px',
        }}></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-14 md:py-20">
        {/* Top section */}
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          {/* Left - Brand & Subscribe */}
          <div className="flex flex-col gap-6 lg:max-w-sm">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-full bg-primary-500 flex items-center justify-center">
                <i className="ri-bar-chart-2-line text-sm"></i>
              </div>
              <span className="font-heading text-xl font-semibold">Hipobuy</span>
            </div>

            <p className="font-heading text-2xl md:text-3xl leading-tight text-background-100">
              Optimisez vos données.<br />Transformez votre business.
            </p>
          </div>

          {/* Right - Links */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 flex-1">
            <div>
              <h4 className="text-sm font-semibold mb-4 text-background-50">{t('nav_home')}</h4>
              <div className="flex flex-col gap-2.5">
                <Link to="/" className="text-sm text-background-300 hover:text-background-50 transition-colors">{t('nav_home')}</Link>
                <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="text-sm text-background-300 hover:text-background-50 transition-colors">Guide</a>
                <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="text-sm text-background-300 hover:text-background-50 transition-colors">Templates</a>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold mb-4 text-background-50">{t('nav_categories')}</h4>
              <div className="flex flex-col gap-2.5">
                <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-300 hover:text-background-50 transition-colors">Shoes</a>
                <a href="https://kaspreadsheet.com/category-913-T-Shirts.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-300 hover:text-background-50 transition-colors">T-Shirts</a>
                <a href="https://kaspreadsheet.com/category-914-Jackets.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-300 hover:text-background-50 transition-colors">Jackets</a>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold mb-4 text-background-50">Articles</h4>
              <div className="flex flex-col gap-2.5">
                <Link to="/article/guide-complet-hipobuy-spreadsheet" className="text-sm text-background-300 hover:text-background-50 transition-colors">Guide Complet</Link>
                <Link to="/article/maitriser-hipobuy-spreadsheet-7-jours" className="text-sm text-background-300 hover:text-background-50 transition-colors">Maîtriser en 7 Jours</Link>
                <Link to="/article/hipobuy-spreadsheet-vs-excel" className="text-sm text-background-300 hover:text-background-50 transition-colors">vs Excel</Link>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold mb-4 text-background-50">Liens</h4>
              <div className="flex flex-col gap-2.5">
                <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="text-sm text-background-300 hover:text-background-50 transition-colors">{t('cta_main_site')}</a>
                <span className="text-sm text-background-300 cursor-pointer hover:text-background-50 transition-colors">{t('footer_privacy')}</span>
                <span className="text-sm text-background-300 cursor-pointer hover:text-background-50 transition-colors">{t('footer_terms')}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 mt-12 pt-8 border-t border-background-800/50">
          <span className="text-xs text-background-400">{t('footer_copyright')}</span>

          <div className="flex items-center gap-3">
            <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="w-9 h-9 rounded-lg border border-background-700 flex items-center justify-center text-background-300 hover:text-background-50 hover:border-background-500 transition-colors cursor-pointer">
              <i className="ri-twitter-x-line text-sm"></i>
            </a>
            <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="w-9 h-9 rounded-lg border border-background-700 flex items-center justify-center text-background-300 hover:text-background-50 hover:border-background-500 transition-colors cursor-pointer">
              <i className="ri-facebook-line text-sm"></i>
            </a>
            <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="w-9 h-9 rounded-lg border border-background-700 flex items-center justify-center text-background-300 hover:text-background-50 hover:border-background-500 transition-colors cursor-pointer">
              <i className="ri-instagram-line text-sm"></i>
            </a>
            <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="w-9 h-9 rounded-lg border border-background-700 flex items-center justify-center text-background-300 hover:text-background-50 hover:border-background-500 transition-colors cursor-pointer">
              <i className="ri-linkedin-line text-sm"></i>
            </a>
          </div>

          <span className="text-xs text-background-400 cursor-pointer hover:text-background-300 transition-colors">{t('footer_privacy')}</span>
        </div>
      </div>
    </footer>
  );
}